exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".addhead[data-v-0e1b5168]{margin-top:20px;padding-right:20px}.addhead ul li[data-v-0e1b5168]{width:100%}\n", ""]);

// exports
